import setQueryParamsToString from '../utils/setQueryParamsToString';
import { getHeaders } from './authentication';

const GET_DASHBOARD_REPORTS_ORDERS_REQUEST = 'GET_DASHBOARD_REPORTS_ORDERS_REQUEST';
const GET_DASHBOARD_REPORTS_ORDERS_SUCCESS = 'GET_DASHBOARD_REPORTS_ORDERS_SUCCESS';
const GET_DASHBOARD_REPORTS_ORDERS_FAILURE = 'GET_DASHBOARD_REPORTS_ORDERS_FAILURE';
const GET_DASHBOARD_REPORTS_ORDERS_RESET = 'GET_DASHBOARD_REPORTS_ORDERS_RESET';

const initialState = {
  data: null,
  error: null,
  fetching: false,
};

export const getDashboardReportPharmacies = (queryParams) => {
  return {
    types: [
      GET_DASHBOARD_REPORTS_ORDERS_REQUEST,
      GET_DASHBOARD_REPORTS_ORDERS_SUCCESS,
      GET_DASHBOARD_REPORTS_ORDERS_FAILURE,
    ],
    payload: {
      request: {
        url: '/orders/support/reports' + setQueryParamsToString(queryParams),
        method: 'GET',
        headers: getHeaders(),
      },
    },
  };
};

export const getDashboardReportPharmaciesReset = () => ({
  type: GET_DASHBOARD_REPORTS_ORDERS_RESET,
});

const dashboardReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_REPORTS_ORDERS_REQUEST:
      return { ...state, fetching: true };
    case GET_DASHBOARD_REPORTS_ORDERS_SUCCESS:
      return { ...state, fetching: false, data: action.payload.data };
    case GET_DASHBOARD_REPORTS_ORDERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error:
          action.error?.response?.data?.error?.text || action.error.message,
      };
    case GET_DASHBOARD_REPORTS_ORDERS_RESET:
      return { data: null, fetching: false, error: null };
    default:
      return state;
  }
};

export default dashboardReportsReducer;
